<template>
    <footer class="menu">
        <hr>
        <router-link to="/">Heim</router-link>
    </footer>
</template>

<script>
    export default {
        name: 'MainFooter'
    }
</script>

<style scoped>

    footer{
        margin-bottom: 30px;

    }
    footer.menu{
        font-size: 0.8em;
    }
    footer.menu hr{
        font-size: 0.8em;
        margin-top: 30px;
        margin-bottom: 30px;
    }
    footer.menu a{
        border: 1px solid white;
        border-radius: 5px;
        padding: 5px 10px;
        margin-right: 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/MainFooter.vue